import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, of, switchMap } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const autoAuthGuard: CanActivateFn = (_route, _state) => {
	const authService = inject(AuthenticationService);

	return authService.authUser$.pipe(
		switchMap(user => {
			if (!user) {
				return authService.autoAuthUser();
			}
			return of(user);
		}),
		map(() => {
			return true;
		}),
	);
};
